"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setInternalUseGACookie = setInternalUseGACookie;

var _cookiesJs = _interopRequireDefault(require("cookies-js"));

var _featureDetection = require("@eb/feature-detection");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Set a cookie with the GA client ID, so that sending events
 *  on the backend results in a consistent chain of actions
 *
 *  You may wonder why we're not just pulling the GA cookie.
 *  GA makes no promises about their internal implementation,
 *  just what's available through the API. If they change their
 *  cookie, we still get the right ID using the method here.
 */
function setInternalUseGACookie() {
  var ga = (0, _featureDetection.getWindowObject)('ga');
  var expirationDate;

  if (ga) {
    expirationDate = new Date(); // roughly match GA's expiration

    expirationDate.setFullYear(expirationDate.getFullYear() + 1); // wrap in async library call

    ga(function (tracker) {
      var clientId = tracker.get('clientId'),
          cookieProperties = {
        expires: expirationDate,
        path: '/'
      };

      _cookiesJs.default.set('ebGAClientId', clientId, cookieProperties);
    });
  }
}
//# sourceMappingURL=set-internal-use-ga-cookie.js.map